import React from 'react';
import { Spin, Table } from 'antd';
import { DownOutlined, RightOutlined } from '@ant-design/icons';

import { renderDiffDisplay } from './renderDiffDisplay';
import { IDeploymentTable } from './typed';

const DeploymentTable: React.FC<IDeploymentTable> = ({ loading = false, tableProps }) => {
  return (
    <Spin spinning={loading}>
      <Table
        sticky
        size="middle"
        pagination={false}
        scroll={{ x: '100%', y: '100%' }}
        rowKey={(record) => {
          return record?.id ?? record;
        }}
        expandable={{
          columnWidth: 40,
          expandedRowRender: (record) => renderDiffDisplay(record),
          expandIcon: ({ expanded, onExpand, record }) => {
            return (
              <div style={{ textAlign: 'left' }}>
                {expanded ? (
                  <DownOutlined onClick={(e) => onExpand(record, e)} />
                ) : (
                  <RightOutlined onClick={(e) => onExpand(record, e)} />
                )}
              </div>
            );
          },
        }}
        {...tableProps}
      />
    </Spin>
  );
};

export default DeploymentTable;
